import { FormattedMessage } from 'react-intl';
import styles from './RepaymentScheduleModal.module.css';
import messages from './RepaymentScheduleModal.messages';
import RepaymentScheduleTable from './repaymentScheduleTable/RepaymentScheduleTable';
import { useQuery } from '@tanstack/react-query';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';
import { fetchGetFormalOffers } from '@iwoca/lapi-client/edge';
import { normaliseRepaymentSchedule } from '../../MyOffers.helpers';
import { NormalisedRepaymentSchedule } from '../../MyOffers.types';
import MainContentPending from '../../../pageStructure/mainContentPending';

const RepaymentScheduleModal = ({
    offerId,
    drawdownAmount
}: {
    offerId: string;
    drawdownAmount: number;
}) => {
    const stateKey = useStateKey();

    const { data: formalOffer } = useQuery({
        queryKey: ['formal_offers', stateKey, offerId],
        queryFn: () => fetchGetFormalOffers({ stateKey: stateKey! }),
        select: (data) =>
            data.data?.formal_offers.find(
                (formal_offer) => formal_offer?.offer_id === offerId
            )
    });

    const productType = formalOffer ? formalOffer.product_type : null;

    const { data: drawdownSchedule } = useQuery({
        queryKey: [
            'draw_down_repayment_schedule',
            stateKey,
            drawdownAmount,
            productType,
            offerId
        ],
        queryFn: async () => {
            // eslint-disable-next-line pandora/prefer-lapi-client
            const response = await fetch(
                `/api/lending/edge/draw_down_repayment_schedule/${stateKey}/${productType}/${offerId}/?amount=${drawdownAmount}`
            );

            return response.json();
        },
        enabled: productType !== null
    });

    if (formalOffer && drawdownSchedule && drawdownSchedule.data) {
        //todo: remove all this normalisation logic
        const repaymentSchedule: NonNullable<NormalisedRepaymentSchedule> =
            normaliseRepaymentSchedule({
                formalOffer,
                repaymentSchedule: drawdownSchedule.data
            })!;

        return (
            <div
                data-testid="repayments-schedule-modal"
                className={styles.RepaymentScheduleModal}
            >
                <div className={styles.title}>
                    {repaymentSchedule.duration ? (
                        <FormattedMessage
                            {...messages.title}
                            values={{ duration: repaymentSchedule.duration }}
                        />
                    ) : (
                        <FormattedMessage {...messages.exampleTitle} />
                    )}
                </div>

                <RepaymentScheduleTable repaymentSchedule={repaymentSchedule} />
            </div>
        );
    } else return <MainContentPending />;
};

// eslint-disable-next-line import/no-default-export
export default RepaymentScheduleModal;
